// multi row layout with icons and infos
export const CUBES_MODULE_LAYOUT = [
  {
    items: [
      { info_key:  null , icon: null, theme: 'none'},
      { info_key: 'impf', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key: 'masimpf', icon: null, theme: 'navy'},
    ],
  },
  {
    items: [
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key: 'bmda', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key: 'hyg', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'none'},
    ],
  },
  {
    items: [
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key:  null , icon: null, theme: 'none'},
      { info_key: 'hivsti', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key: 'zahdie', icon: null, theme: 'navy'},
    ],
  },
  {
    items: [
      { info_key:  null , icon: null, theme: 'none'},
      { info_key: 'amtdie', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'blue'},
      { info_key: 'einsch', icon: null, theme: 'navy'},
      { info_key:  null , icon: null, theme: 'blue'},
    ],
  },
    {
        items: [
            { info_key: 'prostSchG' , icon: null, theme: 'navy'},
            { info_key:  null , icon: null, theme: 'none'},
            { info_key:  null , icon: null, theme: 'blue'},
            { info_key: 'belehrung', icon: null, theme: 'navy'},
            { info_key:  null , icon: null, theme: 'blue'},
        ],
    },
];

export const CUBES_MODULE_INFO = {
    impf: {
        title: 'Impfberatung',
        short_title: 'Impfberatung',
        abbreviation: 'RDBMI',
        icon_filename: 'vaccinate',
        status: 'Einsatzbereit',
        description: 'Das Fachmodul unterstützt die Planung und Durchführung reisemedizinischer Beratungen und Impfungen. Bürger:innen können Termine über das Online-Portal buchen und relevante Angaben für die Beratung bereitstellen. Die Mitarbeitenden können diese Informationen im Fachmodul einsehen und für die Dokumentation, Anamnese und Erstellung von Bescheinigungen nutzen.',
    },
    bmda: {
        title: 'Heilberufe/Medizinalkartei',
        short_title: 'Medizinalaufsicht',
        abbreviation: 'BMEDA',
        icon_filename: 'checkmark_house',
        status: 'Einsatzbereit',
        description: 'Das Fachmodul dient der zentralen Erfassung und Verwaltung aller Personen, die in einem Heilberuf tätig sind. Einträge können sowohl von den Heilberufler:innen selbst als auch von Mitarbeitenden des Gesundheitsamts angelegt bzw. geändert werden. Änderungen durch Heilberufler:innen, werden durch das Gesundheitsamt validiert, bevor sie übernommen werden.',
    },
    hyg: {
        title: 'Hygiene-Begehungen',
        short_title: 'Hygiene',
        abbreviation: 'HYG',
        icon_filename: 'hygiene_hands',
        status: 'Einsatzbereit',
        description: 'Das Fachmodul für unterstützt Mitarbeitende des Gesundheitsamts bei der Hygiene- und Infektionsüberwachung von medizinischen Einrichtungen wie Krankenhäusern, Gemeinschaftseinrichtungen, Praxen oder anderen Orten, bei denen Hygiene und Krankheitsprävention relevant sind.',
    },
    masimpf: {
        title: 'Masern- und Impfschutzberatung',
        short_title: '',
        abbreviation: 'IMP',
        icon_filename: 'virus_defense_solid',
        status: 'Einsatzbereit',
        description: 'Bei der Impfberatung finden Impfungen und Impfberatungen statt. Die Impfungen haben individuelle Anamnesebögen und Aufklärungsbögen. Eine Bescheinigung wird anschließend erstellt und den Bürger:innen zur Vorlage bei der Krankenkasse ausgehändigt.',
    },
    hivsti: {
        title: 'HIV-STI',
        short_title: '',
        abbreviation: 'HIV',
        icon_filename: 'hiv',
        status: 'Einsatzbereit',
        description: 'Im Fachmodul werden Personen anonym erfasst (keine Anbindung an den Stammdatenkonverter). Das Modul bietet eine anonyme, datenschutzkonforme und effiziente Plattform für Terminierung und Beratung im Bereich HIV-STI und sexueller Gesundheit – mit Fokus auf Nutzerfreundlichkeit und minimaler Datenerfassung.',
    },
    zahdie: {
        title: 'Zahnärztlicher Dienst',
        short_title: '',
        abbreviation: 'ZAD',
        icon_filename: 'dentistry',
        status: 'Einsatzbereit',
        description: 'Das Fachmodul unterstützt die Mitarbeitenden der Gesundheitsämter bei der Planung und Durchführung von zahnärztlichen Reihenuntersuchungen und Prophylaxemaßnahmen an Schulen und Kindertagesstätten (Kitas).',
    },
    amtdie: {
        title: 'Amtsärztlicher Dienst ',
        short_title: '',
        abbreviation: 'AÄD',
        icon_filename: 'doc',
        status: 'Demnächst verfügbar',
        description: 'Das Fachmodul unterstützt die Gesundheitsämter bei der Aufnahme von Anliegen, der Dokumentation des Prozesses zur Erstellung von Gutachten oder Attesten sowie der Kommunikation mit betroffenen Bürger:innen.',
    },
    prostSchG: {
        title: 'Prostitutionsschutzgesetz',
        short_title: '',
        abbreviation: 'ProstSchG',
        icon_filename: 'prost_sch_g',
        description: 'Das Fachmodul unterstützt die Mitarbeitenden der Gesundheitsämter bei der Erfassung und Verwaltung von Personen im Rahmen der gesundheitlichen Beratung nach dem Prostitutionsschutzgesetz.',
    },
    belehrung: {
        title: 'Belehrung nach dem Infektionsschutzgesetz',
        short_title: '',
        abbreviation: 'IfSG-Belehrung',
        icon_filename: 'belehrung',
        description: 'Im Fachmodul können Belehrungen für Personen, die im Bereich der Lebensmittelverarbeitung tätig sind, zentral erfasst und verwaltet werden. Belehrungstermine lassen sich bequem über das Online-Portal vereinbaren.',
    },
    einsch: {
        title: 'Einschulungsuntersuchung',
        short_title: '',
        abbreviation: 'ESU',
        icon_filename: 'schoolkids',
        status: 'Einsatzbereit',
        description: 'Das Fachmodul befasst sich mit der vorgeschriebenen schulärztlichen Untersuchung als verbindlicher Bestandteil des Schulaufnahmeverfahrens. Es handelt sich um eine Vorsorgeuntersuchung, die auf die spezifischen Anforderungen in der Schule ausgerichtet ist.',
    },
    def: {
        title: 'Unbekannter Titel',
        short_title: 'Unbekannt',
        abbreviation: '-',
        icon_filename: null,
        status: '-',
        description: 'Keine zusätzlichen Informationen verfügbar.',
    },
};
